import React from "react";
import excelIcon from '../../../../assets/images/excel48.png';
import pdfIcon from '../../../../assets/images/pdf.png';
import csvIcon from '../../../../assets/images/csv.png';
import txtIcon from '../../../../assets/images/txt.png';
import { Button } from '@material-ui/core';
import { toast } from 'react-toastify';

function OperationButtons({
    isLoading,
    exportTable,
    generateDinamicReport,
    currentReport,
    selectedItems,
    processSelectedItems,
    bulkSelectMode,
    toggleBulkSelectMode 
}) {

  const hasSelectedItems = () => {
    return selectedItems.length > 0;
  };

  return (
    <>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {/* Esquerda: Relatório e exportações */}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Button
            color="primary"
            style={{ lineHeight: 1.5, height: '40px', marginRight: '8px' }}
            variant="contained"
            disabled={isLoading}
            onClick={() => generateDinamicReport()}
          >
            Gerar Relatório
          </Button>
          {currentReport?.exportarExcel && (
            <img
              src={excelIcon}
              onClick={() => !isLoading && exportTable('excel')}
              style={{ cursor: isLoading ? 'auto' : 'pointer', marginRight: '8px' }}
              alt="Exportar Excel"
            />
          )}
          {currentReport?.exportarPdf && (
            <img
              src={pdfIcon}
              onClick={() => !isLoading && exportTable('pdf')}
              style={{ cursor: isLoading ? 'auto' : 'pointer', marginBottom: '4px', marginRight: '8px' }}
              width="40"
              alt="Exportar PDF"
            />
          )}
          {currentReport?.exportarCSV && (
            <img
              src={csvIcon}
              onClick={() => !isLoading && exportTable('csv')}
              style={{ cursor: isLoading ? 'auto' : 'pointer', marginBottom: '4px', marginRight: '8px' }}
              width="40"
              alt="Exportar CSV"
            />
          )}
          {currentReport?.exportarTxt && (
            <img
              src={txtIcon}
              onClick={() => !isLoading && exportTable('txt')}
              style={{ cursor: isLoading ? 'auto' : 'pointer', marginBottom: '4px', marginRight: '8px' }}
              width="40"
              alt="Exportar TXT"
            />
          )}
        </div>

        {/* Direita: Processar Selecionados e Toggle */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <Button
            variant="contained"
            color="primary"
            style={{ 
              lineHeight: 1.5,
              height: '40px',
              backgroundColor: hasSelectedItems() ? '#1976d2' : '#f5f5f5',
              color: hasSelectedItems() ? '#fff' : 'rgba(0, 0, 0, 0.26)'
            }}
            disabled={isLoading || !hasSelectedItems()}
            onClick={() => {
              if (!hasSelectedItems()) {
                toast.warning("Nenhum item selecionado para processar");
                return;
              }
              processSelectedItems(selectedItems);
            }}
          >
            Processar Selecionados
          </Button>

          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            padding: '8px 12px',
            backgroundColor: '#f5f5f5',
            borderRadius: '4px',
            border: '1px solid #e0e0e0'
          }}>
            <label className="switch" style={{ marginRight: '8px' }}>
              <input
                type="checkbox"
                checked={bulkSelectMode.grid1}
                onChange={() => toggleBulkSelectMode(1)}
                disabled={isLoading}
              />
              <span className="slider round"></span>
            </label>
            <span style={{ 
              fontSize: '14px',
              fontWeight: '500',
              color: isLoading ? 'rgba(0, 0, 0, 0.26)' : 'rgba(0, 0, 0, 0.87)'
            }}>
              Marcar Todos
            </span>
          </div>
        </div>
      </div>

      <style jsx>{`
        /* Switch estilo toggle - Versão Azul */
        .switch {
          position: relative;
          display: inline-block;
          width: 50px;
          height: 24px;
        }
        
        .switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }
        
        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #90caf9; /* Azul claro/opaco */
          transition: .4s;
          border-radius: 24px;
        }
        
        .slider:before {
          position: absolute;
          content: "";
          height: 16px;
          width: 16px;
          left: 4px;
          bottom: 4px;
          background-color: white;
          transition: .4s;
          border-radius: 50%;
          box-shadow: 0 1px 3px rgba(0,0,0,0.3);
        }
        
        input:checked + .slider {
          background-color: #1976d2; /* Azul mais vivo */
        }
        
        input:checked + .slider:before {
          transform: translateX(26px);
        }
        
        /* Efeito de hover */
        .switch:hover .slider {
          background-color: #64b5f6; /* Azul médio no hover */
        }
        
        input:checked:hover + .slider {
          background-color: #1565c0; /* Azul mais escuro no hover quando marcado */
        }
        
        /* Estilo quando desabilitado */
        input:disabled + .slider {
          background-color: #bbdefb; /* Azul muito claro quando desabilitado */
          cursor: not-allowed;
        }
        
        input:disabled:checked + .slider {
          background-color: #e3f2fd; /* Azul quase branco quando desabilitado e marcado */
        }
      `}</style>
    </>
  );
}

export default OperationButtons;